import { ApiQueryParams } from '@frontend/api-utils';
import { ObjectSelectInput } from '@frontend/components/basic-forms';
import { Spinner } from '@frontend/elements';
import { useLocale } from '@frontend/lang';
import { ProductClient, ProductRequirementClient } from '@frontend/product/api';
import { defaultMapWithAttributes } from '@frontend/product/badge';
import { IProduct, ProductQueryParams } from '@frontend/product/types';
import { useAccountRepository } from '@frontend/repository';
import React, { useState } from 'react';

const ID = 'product-not-in-requirement-select';
export interface ProductNotInRequirementSelectProps {
    id?: string;
    label?: React.ReactNode;
    required?: boolean;
    submitted: boolean;
    onChange?: (newValue: string | null) => void;
    onChangeObject?: (newValue: IProduct | null) => void;
    value?: string | null;
    className?: string;
    disabled?: boolean;
    useConditionedStyling?: boolean;
    isClearable?: boolean;
    allowURLChange?: boolean;
    createEnabled?: boolean;
    queryParams?: ApiQueryParams<ProductQueryParams>;
    disableFetch?: boolean;
    subset?: string[];
    onFocus?: () => void;
    onBlur?: () => void;
    spotId: string;
}

export const ProductNotInRequirementSelect = (props: ProductNotInRequirementSelectProps) => {
    const { locale } = useLocale();
    const {
        store: { currentAccount }
    } = useAccountRepository();
    const [v, cV] = useState<IProduct | null>(null);
    if (!currentAccount) {
        return <Spinner />;
    }
    return (
        <ObjectSelectInput<IProduct, ProductQueryParams>
            id={`${ID}${props.id && '-' + props.id}`}
            label='Product'
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={{ ...props.queryParams }}
            value={v}
            isClearable={props.isClearable}
            idValue={props.value || v?.id}
            fetch={(arg) => ProductRequirementClient.fetchProductsNotInRequirement(currentAccount, props.spotId, arg)}
            itemLabel={(prod: IProduct) => defaultMapWithAttributes(prod, locale)}
            disableFetch={props.disableFetch}
            disabled={props.disabled}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            subset={props.subset}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'product_id',
                          fetch: (id) =>
                              ProductClient.resolveProducts([id]).then((res) => {
                                  return res.results[0];
                              })
                      }
                    : undefined
            }
        />
    );
};
